import { JourneysLegacyAuthRefreshRoute } from './-components';
import { resolveAccountRedirect } from './-account-redirects';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/account/$')({
  // Legacy Unity `/account/*` URLs are forwarded to their canonical `/settings/*`
  // home natively. Unmatched paths (workspace-scoped settings, cancelled states,
  // dead targets) return null and fall through to the embedded Journeys app.
  beforeLoad: ({ params }) => {
    const target = resolveAccountRedirect(params._splat ?? '');
    if (target != null) {
      throw redirect({ to: target });
    }
  },
  component: JourneysLegacyAuthRefreshRoute,
});
